const onlineShopping = {
  'onlineShopping-1': 'Online Shopping',
  'onlineShopping-2': 'Demnächst verfügbar'
};

export default onlineShopping;
